import * as LabelPrimitive from '@radix-ui/react-label';
import type { ComponentProps } from 'react';

import { cn } from '@/shared/lib/utils';

const styleSaisie = cn(
  'w-full rounded-[--radius-astro] border border-bordure bg-fond-eleve',
  'px-3 py-2 text-sm text-texte',
  'placeholder:text-texte-faible',
  'transition-[border-color,box-shadow] duration-150',
  'hover:border-bordure-forte',
  'focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/25',
  'disabled:cursor-not-allowed disabled:opacity-60',
  // Etat invalide pilote par `aria-invalid` : une seule source de verite pour
  // le style et pour les lecteurs d'ecran.
  'aria-[invalid=true]:border-danger aria-[invalid=true]:ring-danger/25',
);

export function Saisie({ className, ...reste }: ComponentProps<'input'>) {
  return <input className={cn(styleSaisie, 'h-10', className)} {...reste} />;
}

export function ZoneTexte({ className, ...reste }: ComponentProps<'textarea'>) {
  return <textarea className={cn(styleSaisie, 'min-h-24 resize-y', className)} {...reste} />;
}

export function Etiquette({ className, ...reste }: ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      className={cn(
        'text-sm font-medium text-texte-doux',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-60',
        className,
      )}
      {...reste}
    />
  );
}

/** Texte d'aide sous un champ. */
export function Aide({ className, ...reste }: ComponentProps<'p'>) {
  return <p className={cn('text-xs text-texte-faible', className)} {...reste} />;
}

/**
 * Message d'erreur d'un champ.
 *
 * `role="alert"` : l'erreur est annoncee des son apparition, sans que l'utilisateur
 * ait a re-parcourir le formulaire pour la decouvrir.
 */
export function ErreurChamp({ className, children, ...reste }: ComponentProps<'p'>) {
  if (!children) return null;

  return (
    <p role="alert" className={cn('text-xs font-medium text-danger', className)} {...reste}>
      {children}
    </p>
  );
}
